import React, { FC } from 'react';

import { ProtectedRoute } from 'components/templates';
import Header from './Header';

import { LoginPromiseType } from 'queries/user/LOGIN';

type MainLayoutProps = {
  data: LoginPromiseType | undefined;
  isLoading: boolean;
  isAdmin: boolean;
};

const MainLayout: FC<MainLayoutProps> = ({ data, isLoading, isAdmin }) => (
  <>
    <Header isAdmin={isAdmin} />
    <ProtectedRoute isAllowed={!isLoading && Boolean(data?.success)} />
  </>
);

export default MainLayout;
